/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ServiceObject
 */
export interface ServiceObject {
  /**
   *
   * @type {number}
   * @memberof ServiceObject
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof ServiceObject
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof ServiceObject
   */
  slug?: string | null
}

/**
 * Check if a given object implements the ServiceObject interface.
 */
export function instanceOfServiceObject(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'name' in value

  return isInstance
}

export function ServiceObjectFromJSON(json: any): ServiceObject {
  return ServiceObjectFromJSONTyped(json, false)
}

export function ServiceObjectFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ServiceObject {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
    slug: !exists(json, 'slug') ? undefined : json['slug'],
  }
}

export function ServiceObjectToJSON(value?: ServiceObject | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    slug: value.slug,
  }
}
